/// <amd-module name="typeahead/features/TwoLineDisplayParamModifier"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {SuggestionRendererUtils} from "typeahead/core/presentation/SuggestionRendererUtils";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult} from "typeahead/core/Suggestion";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration1: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage", "FlightsLandingPage", "HotelsLandingPage", "Hotels.Search",
            "Flights.Search", "Cars.Search", "LX.Search", "Packages.Search",
            "CarsLandingPage", "LXLandingPage", "PackageLandingPage", "RailsLandingPage"],
        experiment: {
            id: 33686,
            name: "ESS_Two_Line_Display",
            value: 1,
        },
        lobs: ["FLIGHTS", "HOTELS", "CARS", "PACKAGES", "ACTIVITIES", "RAILS"],
    },
];

const configuration2: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage", "FlightsLandingPage", "HotelsLandingPage", "Hotels.Search",
            "Flights.Search", "Cars.Search", "LX.Search", "Packages.Search",
            "CarsLandingPage", "LXLandingPage", "PackageLandingPage", "RailsLandingPage"],
        experiment: {
            id: 33686,
            name: "ESS_Two_Line_Display",
            value: 2,
        },
        lobs: ["FLIGHTS", "HOTELS", "CARS", "PACKAGES", "ACTIVITIES", "RAILS"],
    },
];

const TWO_LINE_DISPLAY = "consistent_display";

export class TwoLineDisplayParamModifier implements IRequestUrlParamModifier,
    IExperimentalFeature, ISuggestionsModifier {

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
        ISuggestServiceQueryParams {
        addFeatureFlag(TWO_LINE_DISPLAY, configuration1, params, context);
        addFeatureFlag(TWO_LINE_DISPLAY, configuration2, params, context);
        return params;
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration1);
    }

    public modifySuggestions(suggestions: IEssSuggestionResult[], context: IContext, options: any): object[] {
        if (!(suggestions && suggestions.length > 0)) {
            return suggestions;
        }
        if (!ExecutionHelper.shouldExecute(context, configuration1)
            && !ExecutionHelper.shouldExecute(context, configuration2)) {
            return suggestions;
        }
        suggestions.forEach((suggestion) => {
            if (!suggestion || !suggestion.regionNames || !suggestion.regionNames.displayName) {
                return;
            }
            if (suggestion.category === "GOOGLEMAPS") {
                const displayName = suggestion.regionNames.displayName;
                if (displayName) {
                    const parts = displayName.split(",");
                    suggestion.regionNames.displayName =
                        `<fl>${parts[0]}</fl> ${parts.length > 1 ? `<sl>${parts.slice(1).join(", ")}</sl>` : ""}`;
                }
            } else if (!TypeaheadUtils.isWithinMobileBreakpoint()) {
                suggestion.regionNames.displayName += SuggestionRendererUtils.formatConsistentDisplayType(
                    SuggestionRendererUtils.getTextType(suggestion));
            }

            if (ExecutionHelper.shouldExecute(context, configuration1)
                && suggestion.regionNames.displayName.indexOf(SuggestionRendererUtils.slOpenTag) !== -1) {
                suggestion.regionNames.displayName =
                    suggestion.regionNames.displayName.replace(SuggestionRendererUtils.slOpenTag,
                        `<sl style='color:dimgray'>`);
            }
        });

        return suggestions;
    }

}
